import { ISnackbarNotification } from '../../@types/redux';
import { createReducer } from '@reduxjs/toolkit';
import GeneralActions from './actions';

export interface IGeneralState {
    division : string;
    notifications : Array<ISnackbarNotification>;
    isNavDrawerOpen : boolean;
}

const initialState = {
    division: '',
    notifications: [],
    isNavDrawerOpen: false
};

const generalReducer = createReducer<IGeneralState>(initialState, (builder) => {
    builder.addCase(GeneralActions.enqueueSnackbar, (state, action) => {
        state.notifications.push(action.payload);
    });

    builder.addCase(GeneralActions.setNavDrawer, (state, action) => {
        state.isNavDrawerOpen = action.payload;
    });
    
    builder.addCase(GeneralActions.removeSnackbar, (state, action) => {
        state.notifications.filter(notification => notification.key !== action.payload);
    });
});

export default generalReducer;

